import React from 'react'
import whyChoose from '../../assets/landing/why-choose.png'
import card1 from '../../assets/landing/card-21.png'
import card2 from '../../assets/landing/card-22.png'

import card2Anim from '../../assets/landing/card-22.json'
import card1Anim from '../../assets/landing/card-21.json'

import colab_1 from '../../assets/landing/collab_ex_parallax/l1.png'
import colab_2 from '../../assets/landing/collab_ex_parallax/l2.png'
import colab_3 from '../../assets/landing/collab_ex_parallax/l3.png'
import colab_4 from '../../assets/landing/collab_ex_parallax/l4.png'
import colab_5 from '../../assets/landing/collab_ex_parallax/l5.png'
import colab_6 from '../../assets/landing/collab_ex_parallax/l6.png'

import card3 from '../../assets/landing/card-23.png'
import card4 from '../../assets/landing/card-24.png'
import Lottie from 'lottie-react'
import card21Anim from '../../assets/landing/card-21-bg.json'
import parallaxBg from '../../assets/landing/whyUs_parallax_bg.png'
import parallaxCubes from '../../assets/landing/whyUs_parallax_cubes.png'
import parallaxCube from '../../assets/landing/whyUs_parallax_cube.png'
import parallaxHand from '../../assets/landing/whyUs_parallax_hand.png'

import architect_parallax1 from '../../assets/landing/architcts_parallax/Archt-1.png'
import architect_parallax2 from '../../assets/landing/architcts_parallax/Archt-2.png'
import architect_parallax3 from '../../assets/landing/architcts_parallax/Archt-3.png'
import architect_parallax4 from '../../assets/landing/architcts_parallax/Archt-4.png'




import { MouseParallax, ScrollParallax } from "react-just-parallax";
import Tilt from 'react-parallax-tilt';


const WhyUs = () => {

  return (
    <div>
        <div className='h-fit overflow-x-hidden lg:h-[100vh] bg-[#000] grid grid-cols-12 w-full bg-cover bg-right lg:bg-center' >
       <div className='hidden lg:flex col-span-6 w-full pr-12 bg-parallax-why-us bg-cover bg-right h-[100vh] overflow-hidden py-6 z-[10]  items-center justify-center' >
            <div className='w-full h-fit'>
                <div className="relative w-full h-fit">

                <MouseParallax lerpEase={0.03} strength={0.02}  >
                    <img
                      src={parallaxCubes}
                      alt="Image 2"
                      className="absolute top-[-42vh] "
                      style={{ transform: 'translateZ(-30px) translatex(-30px)' }} 
                      />
                  </MouseParallax>
                    <MouseParallax lerpEase={0.02} strength={0.06}>

                    <div className='flex '>
                      <img
                        src={parallaxHand}
                        alt="Image 3"
                        className="absolute top-[-42vh] "
                        style={{ transform: 'translatex(-40px) ' }}
                        />
                      <img
                        src={parallaxCube}
                        alt="Image 4"
                        className="absolute top-[-42vh] "
                        style={{ transform: 'translatex(-30px) ' }}
                        />

                    </div>
                    </MouseParallax>
                </div>
                
            </div>

       </div>
          <div className='col-span-12 lg:col-span-6  text-[#fff] bg-gradient-to-r from-[#050818] to-[#0B0C13] h-full w-full flex flex-col gap-3 justify-center  relative py-20 lg:py-0 px-6 md:px-12 lg:px-24' >
            <span >
              <h2 data-aos="fade-left" data-aos-duration="800" className='text-5xl font-mosk300' >Why choose</h2>
              <h1 data-aos="fade-left" data-aos-duration="900" className='text-6xl font-mosk600' >Bluedoor?</h1>
            </span>
            <p data-aos="fade-left" data-aos-duration="1000" className='font-mosk300 text-xl' >Our story began as passionpreneurs with a profound appreciation for the art of crafting exceptional events. From the foundational basics to the cutting-edge innovations, we understand the integral elements that contribute to a successful event. In today's dynamic world, where events transcend mere gatherings, Blue Door Event Solutions emerges as a boutique agency at the forefront of the industry.</p>
          </div>
        </div>

        

        {/* polygon pages */}

        <div className='bg-[#e2dfd0] flex flex-col' >
              <div className='bg-[#e2dfd0] flex flex-col lg:flex-row items-center justify-center px-6 md:px-12 lg:px-[20%] pt-12 pb-16 md:pb-0' >
                <div data-aos="zoom-in" className=' lg:w-[40%] flex items-center' >
                {/* <div className="absolute inset-0 z-0 top-[-25%] md:top-[-20%] lg:top-[-25%]">
                </div> */}

                <div className='lg:w-[100%] relative'>
                          <Lottie animationData={card1Anim} data-aos="zoom-in"  loop={true}  className="absolute top-0 left-0 w-full h-full" />

                           <img 
                            data-aos="zoom-in" 
                            className=' lg:h-full object-cover w-full' 
                            src={card1} 
                            alt="" 
                          /> 
                      </div>
                </div>
                <div className='text-[#515a69] w-full lg:w-[60%] flex flex-col gap-3' >
                  <h2 data-aos="fade-left" data-aos-duration="800" className='text-4xl' >Innovative <span className='text-5xl font-mosk600' > Approach</span></h2>
                  <p data-aos="fade-left" data-aos-duration="900" className='font-mosk300 text-xl 2xl:text-xl' >By blending experiential events with immersive technology, we reshape event execution and engagement. Modern audiences seek memorable experiences, and we create events that merge reality and imagination.</p>
                </div>
              </div>

              <div className='bg-[#0095da] z-12  blue-polygon pb-[20vh] md:pb-0'  >
                <div className=' flex items-end justify-center px-6 md:px-12 lg:pl-[15%] lg:pr-[20%] h-fit lg:h-[90vh]'>
                  <div className=' flex flex-col-reverse lg:flex-row items-center py-16 pt-32 lg:py-12' >
                      <div className='text-[#fff]  lg:w-[50%] flex flex-col gap-3' >
                        <h2 data-aos="fade-right" data-aos-duration="800" className='text-4xl mosk-300' >Crafting <span className='text-5xl font-mosk600'>Experiences</span></h2>
                        <p data-aos="fade-right" data-aos-duration="900" className='font-mosk300 text-xl 2xl:text-xl'>From galas to product launches, we craft events that captivate the senses and evoke emotions. Through storytelling, installations, and sensory engagement, Blue Door makes guests active participants in the narrative.</p>
                      </div>
                      <div className='lg:top-[6vh] lg:w-[50%] relative'>
                          <Lottie animationData={card2Anim} data-aos="zoom-in"  loop={true} className="absolute top-0 left-0 w-full h-full" />

                          <img 
                            data-aos="zoom-in" 
                            className='h-full object-cover w-full' 
                            src={card2} 
                            alt="" 
                          />
                      </div>
                  </div>
                </div>
              </div>
        </div>

        <div className='flex overflow-x-hidden bg-[#006edc] flex-col lg:flex-row h-fit lg:h-[130vh] lg:overflow-y-hidden'  >
              <div className='bg-[#2f195e] w-full lg:w-[60%] lg:h-[130vh] px-6 md:px-12 lg:px-32 flex flex-col-reverse  lg:flex-col  items-center justify-center purple-polygon py-[20vh] md:py-16 relative top-[-18vh] md:top-0' >
                <div className='text-[#fff] flex flex-col gap-2 pb-12 md:pb-40 lg:pb-12 lg:pb-0' >
                  <h2 data-aos="fade-right" data-aos-duration="800" className='text-4xl'>Collaborative <span className='text-5xl font-mosk600' >Excellence</span></h2>
                  <p data-aos="fade-right" data-aos-duration="900" className='text-xl font-mosk300' >The success of Blue Door lies in our cumulative and collaborative approach to execution. Every event is meticulously planned, bringing together a diverse team of creative visionaries, tech wizards, event planners, and experience architects. This collaborative effort ensures that every aspect, from concept to execution, is flawlessly integrated, creating a harmonious and impactful experience.</p>
                </div>
                <MouseParallax lerpEase={0.03} strength={0.06}  >
                <div  data-aos="fade-right" className="hidden lg:flex relative w-[32vw] h-fit">

                      <img
                      src={colab_1}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <img
                      src={colab_2}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <img
                      src={colab_3}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <MouseParallax lerpEase={0.02} strength={0.01}  >
                      <img
                      src={colab_4}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <MouseParallax lerpEase={0.02} strength={0.02}  >
                      <img
                      src={colab_5}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <img
                      src={colab_6}
                      alt="Image 2"
                      className="absolute top-[-10vh] "
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      </MouseParallax>
                      </MouseParallax>
                </div>
                </MouseParallax>
                <img data-aos="zoom-in" className='lg:hidden w-[90%] md:w-[70%] ' src={card3} alt="" />
              </div>
              
              <div className='w-full bg-[#006edc] h-fit lg:h-full lg:w-[40%] flex flex-col items-center justify-center py-12 lg:py-0 relative top-[-13vh] md:top-0' >
                <img data-aos="zoom-in" className='w-[90%] lg:hidden' src={card4} alt="" />
                <MouseParallax lerpEase={0.03} strength={0.06}>
                <div  data-aos="fade-right" className="hidden lg:flex relative top-[20vh] w-[100%] lg:w-[32vw] ">

                <img
                      src={architect_parallax4}
                      alt="Image 2"
                      className="absolute top-0"
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <MouseParallax lerpEase={0.03} strength={0.01}  >
                      <img
                      src={architect_parallax3}
                      alt="Image 2"
                      className="absolute top-0"
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <MouseParallax lerpEase={0.03} strength={0.01}  >
                      <img
                      src={architect_parallax1}
                      alt="Image 2"
                      className="absolute top-0"
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                      <img
                      src={architect_parallax2}
                      alt="Image 2"
                      className="absolute top-0"
                      style={{ transform: 'translateZ(-30px)' }} 
                      />
                     
                     </MouseParallax>
                     </MouseParallax>
                </div>
                </MouseParallax>
                <div className='text-[#fff] px-6 md:px-12 lg:px-6 relative lg:absolute lg:top-[50%] lg:left-[-5vw]' >
                  <h2  data-aos="fade-left" data-aos-duration="800" className='text-4xl'>Architects of <span className='text-5xl font-mosk600'>Memories</span></h2>
                  <p  data-aos="fade-left" data-aos-duration="900" className='text-xl font-mosk300' >In a world where experiences are valued above all else, Blue Door Event Solutions is not just an agency but an architect of memories. We craft events that touch hearts, stimulate minds, and create lasting impressions. Welcome to the future of events, where our doors lead to where the future belongs.</p>
                </div>
              </div>
        </div>


    </div>
  )
}

export default WhyUs
